import React from "react";
import styles from "./Modal.module.scss";

class Modal extends React.Component {
    state = {
        plotName: "",
        error: false,
    }
    onPlotNameChange = (event) => {
        this.setState({
            plotName: event.target.value
        })
    }
    validateSubmit = (e) => {
        if (this.state.plotName.length <= 0) {
            this.setState({
                error: true
            })
        } else {
            const name = this.state.plotName;
            this.props.onSave(name)
            this.setState({
                plotName: ""
            })
        }


    }
    render() {
        const classes = []
        classes.push(styles.absolute_modal)
        if (this.props.show) {
            classes.push(styles.activate)
        } else {
            classes.push(styles.close)
        }
        return (
            <div className={classes.join(" ")}>
                <div className={styles.modal_title}>
                    <i style={{ fontSize: "30px", color: "#5380E3" }} class="fas fa-chart-bar"></i> <p style={{
                        fontWeight: "bolder",
                        fontSize: "25px",
                        marginLeft: "0.3rem"
                    }}>add {this.props.name.toLowerCase()}</p>
                </div>
                <div style={{
                    marginTop: "0.5rem"
                }}>
                    <label style={{
                        color: "grey"
                    }} for="#plot_name">{this.props.name.toLowerCase()} name</label>
                    <input style={{
                        display: "block",
                        width: "100%",
                        padding: "0.4rem",
                        border: "1px solid #eee",
                        borderRadius: "10px",
                        outline: "none"
                    }} id="plot_name" onChange={this.onPlotNameChange} value={this.state.plotName} placeholder={this.props.name === 'ZONE' ? 'Z1' : this.props.name === 'PLOT' ? 'P1' : 'C1'}></input>
                    {this.state.error ? <small style={{
                        color: "#ff3224"
                    }}>plot name required</small> : null}
                </div>
                <div style={{
                    display: "flex",
                    justifyContent: "end"
                }}>
                    <button onClick={() => this.props.onDiscard()} className={styles.discard}>Discard</button>
                    <button onClick={() => {
                        this.validateSubmit()
                    }} className={styles.save}>Save {this.props.name.toLowerCase()}</button>
                </div>
            </div >
        )
    }
}

export default Modal;